import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueApexCharts from 'vue-apexcharts'
import VueExcelXlsx from "vue-excel-xlsx";
import store from './store';
import JwPagination from 'jw-vue-pagination';
import VueQRCodeComponent from 'vue-qrcode-component'
import VueHtml2Canvas from 'vue-html2canvas';
import Vue2Editor from "vue2-editor";
import LongdoMap from 'longdo-map-vue' 

import 'regenerator-runtime';

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(Vue2Editor);

Vue.config.productionTip = false

Vue.use(LongdoMap, {     
  load: {         
       apiKey: '9b8d7c745502db887b835ebe79b8e563'     
  } 
})

Vue.use(VueExcelXlsx);
Vue.component('jw-pagination', JwPagination);
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue'));
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VueHtml2Canvas);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
